module.exports = require('react/lib/ReactCSSTransitionGroup');


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-addons-css-transition-group/index.js
 ** module id = 2330
 ** module chunks = 0
 **/